import React from "react"
import cx from "classnames"
import { Message } from "@locmod/intl"
import { formatToFixed } from "helpers/formatters"
import { useWallet } from "wallet"
import { useBalance } from "wagmi"
import { useDetailedSxBetslip } from "@/contexts/DetailedSxBetslipContext"
import { getQuickBetStorageValue } from "../QuickBet/QuickBet"
import useChainProviderHook from "@/hooks/useChainProvider"
import messages from "./messages"

const SxChip: React.FC<{
  title: string | Intl.Message
  isActive: boolean
  isDisabled?: boolean
  onClick: () => void
}> = ({ title, isActive, isDisabled, onClick }) => {
  const className = cx(
    "px-3 py-2 text-center w-full rounded-t-xs rounded-b-min",
    {
      "bg-brand-light-500 text-black": isActive,
      "text-accent-grey-100 bg-accent-grey-800 hover:text-brand-light-500":
        !isActive,
      "cursor-not-allowed text-white": isDisabled,
    }
  )
  return (
    <button className={className} onClick={onClick} disabled={isDisabled}>
      <Message
        className="text-caption-12 font-medium uppercase"
        value={title}
      />
    </button>
  )
}

const SxChips: React.FC = () => {
  const { account: address } = useWallet()
  const { defaultToken } = useChainProviderHook()
  const { betAmount, changeBetAmount, maxBet } = useDetailedSxBetslip()

  const { data, isFetching: isBalanceLoading } = useBalance({
    address,
    token: defaultToken?.address as `0x${string}`,
  })

  const { formatted: balance } = data || {}
  if (!address) {
    return null
  }

  const chips = getQuickBetStorageValue()

  const maxBetAmount = Math.min(
    maxBet || Infinity,
    parseFloat((Math.floor((Number(balance) || 0) * 100) / 100).toFixed(2))
  )

  return (
    <div className="flex items-center space-x-[2px] mt-1">
      {chips.map(chipValue => {
        const isActive = +betAmount === +chipValue
        return (
          <SxChip
            key={chipValue}
            title={String(chipValue)}
            isActive={isActive}
            onClick={() => {
              changeBetAmount(String(chipValue))
            }}
          />
        )
      })}
      <SxChip
        title={messages.max}
        isActive={
          Boolean(+betAmount) && +formatToFixed(balance || 0, 2) === +betAmount
        }
        isDisabled={isBalanceLoading}
        onClick={() => {
          changeBetAmount(maxBetAmount.toString())
        }}
      />
    </div>
  )
}

export default SxChips
